const HeroSection = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b85342ce66da9ee1c6414624bd6d34bc.jpg"
          alt="Hudson Valley Camping at Sunset"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-between py-32">
        <div className="mt-8">
          <h1 className="font-serif text-7xl font-bold text-white leading-tight">
            Discover Your<br />
            Hudson Valley<br />
            Adventure
          </h1>
        </div>

        <div className="flex items-end justify-between">
          <a
            href="#destinations"
            className="group px-8 py-4 bg-white rounded-full flex items-center gap-3 hover:bg-cream transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="font-sans font-medium text-gray-900">Explore Destinations</span>
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </a>

          <div className="text-right">
            <p className="text-white text-xl font-light leading-relaxed">
              Your guide to the best camping<br />
              and RVing spots in New York's backyard
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;